// extracted by mini-css-extract-plugin
module.exports = {"embed-container":"wp-embed_embed-container__17OpQ","embed":"wp-embed_embed__ZspB1","ready":"wp-embed_ready__2NjIF"};